/**
 * Demo environment
 */
export const environment = {
    production: true,
    URL_API: "https://demoapi2.gesthispania.es/payyourfines/",
    URL_API_TINY: "https://demoapi2.gesthispania.es/pyf/"
};
